// extracted by mini-css-extract-plugin
export var alertarea = "style-module--alertarea--7f002";
export var buttonarea = "style-module--buttonarea--3002b";
export var container = "style-module--container--ace25";
export var error = "style-module--error--6cb2a";
export var inputarea = "style-module--inputarea--5917f";
export var introduction = "style-module--introduction--4f72b";
export var radioarea = "style-module--radioarea--fa62c";
export var tel = "style-module--tel--b803e";